module.exports = __webpack_public_path__ + "static/media/e-commerce.f48700f6.svg";